<template>
  <h1 class="battle-header" :class="{ 'always-display': alwaysDisplay }">
    <slot>{{ $t('adaptive-test-battle.game-title') }}</slot>
  </h1>
</template>

<script>
export default {
  name: 'BattleHeader',
  props: {
    alwaysDisplay: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
$headerColor: #3c3c69;

.battle-header {
  padding: 0.5em;
  margin: 0;
  background: $headerColor;
  color: white;
  font-weight: bold;
  text-align: center;

  @media (max-width: $minWidthSmallTablet) {
    &.always-display {
      font-size: 1.5em;
    }
    &:not(.always-display) {
      display: none;
    }
  }
}
</style>
